import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Container,
    ContainerSubInfo,
    LabelProtocol,
    LabelCompany,
    LabelInfoText,
    LabelInfoName,
    Image,
    HeaderTitle,
    SubHeaderTitle,
    ContainerHeader,
    ContainerCol,
    SubContainerButton,
    ContainerImage,
    ContainerContent,
    ContainerInformation,
} from './style';
import Button from '../../components/Button/Button';
import ModalAlertInput from '../../components/ModalAlertInput/ModalAlertInput';
import logo from '../../assets/images/logo.png';
import CurrentTime from '../../components/CurrentTime/CurrentTime';
import ModalAlert from '../../components/ModalAlert/ModalAlert';
import {
    fetchAtualizarSenhaStart,
    atualizarSenhaReset,
} from '../../services/store/reducers/endpoints/atualizarSenha';
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo';
import { fetchSendSmsStart } from '../../services/store/reducers/endpoints/sendSms';

class ProtocolDetails extends PureComponent {
    state = {
        titleModal: '',
        messageModal: '',
        phone: '',
        protocolo: '',
        data: '',
        hora: '',
        tipo: '',
        sended: false,
    };
    UNSAFE_componentWillMount() {
        let searchData = this.props.location.search;

        let protocolo = searchData.split('?protocolo=')[1].split('&')[0];
        let data = searchData.split('data=')[1].split('&')[0];
        let hora = searchData.split('hora=')[1].split('&')[0];
        let tipo = searchData.split('tipo=')[1].split('&')[0];

        this.setState({ tipo: decodeURI(tipo), hora: hora, data: data, protocolo: protocolo });
    }
    voltar() {
        window.history.back();
    }

    paraRegisterPoint() {
        window.location.href = '/register-point';
    }

    sendSMS = () => {
        this.setState({ titleModal: 'Atenção', messageModal: 'Informe seu celular: ' });
    };

    setPhone = (value) => {
        this.setState({ phone: value });
    };

    respostaSendSmS = () => {
        this.setState({ sended: false });
        this.setState({ titleModalInfo: 'Sucesso', messageModalInfo: 'SMS enviado com sucesso.' });
        return;
    };
    tratamento = (value, limit) => {
        let reticencias = false;
        if (value.length > limit) {
            reticencias = true;
        }
        value = value.replace(/[ÀÁÂÃÄÅ]/g, 'A');
        value = value.replace(/[àáâãäå]/g, 'a');
        value = value.replace(/[ÈÉÊË]/g, 'E');
        value = value.replace(/[èéê]/g, 'e');
        value = value.replace(/[ÓÒÔ]/g, 'o');
        value = value.replace(/[òóô]/g, 'o');
        value = value.replace(/[íìî]/g, 'i');
        value = value.replace(/[ÍÌÎ]/g, 'i');
        value = value.replace(/[úùû]/g, 'u');
        value = value.replace(/[ÚÙÛ]/g, 'u');

        value = value.substr(0, limit);
        if (reticencias) {
            value += '...';
        }
        return value;
    };

    render() {
        const { protocolo, data, hora, tipo } = this.state;
        const { sagaSendSms } = this.props;
        return (
            <Container>
                <ContainerImage>
                    <Image src={logo} />
                </ContainerImage>
                <CurrentTime></CurrentTime>
                <ContainerHeader>
                    <HeaderTitle>Detalhes do protocolo</HeaderTitle>
                    <SubHeaderTitle></SubHeaderTitle>
                </ContainerHeader>

                <ContainerContent>
                    <ContainerCol>
                        <ContainerInformation>
                            <LabelProtocol>Protocolo nº {protocolo}</LabelProtocol>
                        </ContainerInformation>
                        <ContainerInformation>
                            <LabelCompany>
                                {this.props.home.companyName} - {data} {hora}{' '}
                            </LabelCompany>
                        </ContainerInformation>

                        <ContainerSubInfo>
                            <div>
                                <LabelInfoText>Cliente</LabelInfoText>
                                <br />
                                <LabelInfoName>
                                    {this.props.registerPoint.nomeCliente}
                                </LabelInfoName>
                            </div>
                        </ContainerSubInfo>

                        <ContainerSubInfo marginTop={'20px'}>
                            <LabelInfoText>Unidade</LabelInfoText>
                            <br />
                            <LabelInfoName>{this.props.registerPoint.nomeUnidade}</LabelInfoName>
                        </ContainerSubInfo>

                        <ContainerSubInfo marginTop={'20px'}>
                            <LabelInfoText>Evento</LabelInfoText>
                            <br />
                            <LabelInfoName>{tipo}</LabelInfoName>
                        </ContainerSubInfo>

                        <ContainerSubInfo marginTop={'20px'}>
                            <LabelInfoText>RE</LabelInfoText>
                            <br />
                            <LabelInfoName>{this.props.registerPoint.re}</LabelInfoName>
                        </ContainerSubInfo>
                    </ContainerCol>
                </ContainerContent>

                <SubContainerButton>
                    <Button
                        width='130px'
                        backgroundColor='#40bbca'
                        onClick={() => {
                            this.voltar();
                        }}
                    >
                        Voltar
                    </Button>
                    <Button
                        width='130px'
                        backgroundColor='#40bbca'
                        onClick={() => {
                            this.sendSMS();
                        }}
                    >
                        Enviar SMS
                    </Button>
                </SubContainerButton>

                {
                    //para colocar os pop up
                    this.state.titleModal &&
                        this.state.messageModal &&
                        this.state.titleModal.length > 0 &&
                        this.state.messageModal.length > 0 && (
                            <ModalAlertInput
                                tel={true}
                                setValue={this.setPhone}
                                title={this.state.titleModal}
                                message={this.state.messageModal}
                                onClick={() => {
                                    console.log('phone', this.state.phone);
                                    this.setState({
                                        messageModal: '',
                                        titleModal: '',
                                        sended: true,
                                    });

                                    let company = this.props.home.companyName; //this.tratamento(this.props.home.companyName)
                                    let unidade = this.tratamento(
                                        this.props.registerPoint.nomeUnidade,
                                        15
                                    );
                                    let evento = this.state.tipo; //this.tratamento(this.props.registerPoint.tipo, 15)
                                    let cliente = this.tratamento(
                                        this.props.registerPoint.nomeCliente,
                                        20
                                    );

                                    // console.log(
                                    //     'logs this.props.registerPoint.tipo',
                                    //     this.props.registerPoint.tipo
                                    // );
                                    // console.log('logs this.state', this.state);

                                    let sendSms =
                                        'RE: ' +
                                        this.props.registerPoint.re +
                                        '\nProtocolo: ' +
                                        protocolo +
                                        '\n' +
                                        company +
                                        '\n' +
                                        cliente +
                                        '\n' +
                                        unidade +
                                        '\nEvento: ' +
                                        evento +
                                        '\nData/Hora: ' +
                                        data +
                                        ' ' +
                                        hora;
                                    //para enviar sms
                                    // console.log('Logs sendSms', sendSms);
                                    this.props.fetchSendSmsStart({
                                        telefone:
                                            '55' +
                                            this.state.phone
                                                .replace('(', '')
                                                .replace(') ', '')
                                                .replace('-', ''),
                                        mensagem: sendSms,
                                    });
                                    //window.location.href = '/home'
                                }}
                            />
                        )
                }
                {
                    //para colocar os pop up
                    this.state.titleModalInfo &&
                        this.state.messageModalInfo &&
                        this.state.titleModalInfo.length > 0 &&
                        this.state.messageModalInfo.length > 0 && (
                            <ModalAlert
                                title={this.state.titleModalInfo}
                                message={this.state.messageModalInfo}
                                onClick={() => {
                                    this.setState({ messageModalInfo: '', titleModalInfo: '' });
                                }}
                            />
                        )
                }
                {sagaSendSms && this.state.sended && this.respostaSendSmS()}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    registerPoint: state.registerPoint,
    token: state.token.token,
    configuration: state.configuration,
    home: state.home,
    sagaAtualizarSenha: state.sagaAtualizarSenha.data,
    sagaSendSms: state.sagaSendSms.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value)),
    fetchAtualizarSenhaStart: (mss) => dispatch(fetchAtualizarSenhaStart(mss)),
    atualizarSenhaReset: () => dispatch(atualizarSenhaReset()),
    fetchSendSmsStart: (mss) => dispatch(fetchSendSmsStart(mss)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtocolDetails);
